import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstance30klgvxbw1mx1 as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb as access$checkEncodingConflicts$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { switchMode35g725ikhjpwv as switchMode } from './WriteMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded1h6zoomba5tnf as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstance1crempiiqys0g as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance11ies3wlxhmd7 as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstanceb1xi7131i8df as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance1foc7f9q9rk1s as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.composer_1.nextItem_40n9p2_k$();
  $this.encodeString_424b5v_k$(discriminator);
  $this.composer_1.print_49c4ow_k$(_Char___init__impl__6a9atx(58));
  $this.composer_1.space_po67ue_k$();
  $this.encodeString_424b5v_k$(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor(composer, json, mode, modeReuseCache) {
        return new.target.new_kotlinx_serialization_json_internal_StreamingJsonEncoder_dldtnx_k$(composer, json, mode, modeReuseCache);
      }
      static new_kotlinx_serialization_json_internal_StreamingJsonEncoder_dldtnx_k$(composer, json, mode, modeReuseCache) {
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$();
        $this.composer_1 = composer;
        $this.json_1 = json;
        $this.mode_1 = mode;
        $this.modeReuseCache_1 = modeReuseCache;
        $this.serializersModule_1 = $this.json_1.get_serializersModule_piitvg_k$();
        $this.configuration_1 = $this.json_1.configuration_1;
        $this.forceQuoting_1 = false;
        $this.polymorphicDiscriminator_1 = null;
        $this.polymorphicSerialName_1 = null;
        var i = $this.mode_1.ordinal_1;
        if (!($this.modeReuseCache_1 == null)) {
          if (!($this.modeReuseCache_1[i] === null) || !($this.modeReuseCache_1[i] === $this)) {
            $this.modeReuseCache_1[i] = $this;
          }
        }
        return $this;
      }
      get_json_woos35_k$() {
        return this.json_1;
      }
      static new_kotlinx_serialization_json_internal_StreamingJsonEncoder_g1qrsl_k$(output, json, mode, modeReuseCache) {
        return this.new_kotlinx_serialization_json_internal_StreamingJsonEncoder_dldtnx_k$(Composer(output, json), json, mode, modeReuseCache);
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      shouldEncodeElementDefault_x8eyid_k$(descriptor, index) {
        return this.configuration_1.encodeDefaults_1;
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
          if (this.get_json_woos35_k$().configuration_1.useArrayPolymorphism_1) {
            serializer.serialize_5ase3y_k$(this, value);
            break $l$block;
          }
          var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
          var tmp;
          if (isPolymorphicSerializer) {
            tmp = !this.get_json_woos35_k$().configuration_1.classDiscriminatorMode_1.equals(ClassDiscriminatorMode_NONE_getInstance());
          } else {
            var tmp_0;
            switch (this.get_json_woos35_k$().configuration_1.classDiscriminatorMode_1.ordinal_1) {
              case 0:
              case 2:
                tmp_0 = false;
                break;
              case 1:
                // Inline function 'kotlin.let' call

                var it = serializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$();
                tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_0;
          }
          var needDiscriminator = tmp;
          var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.get_descriptor_wjt6a0_k$(), this.get_json_woos35_k$()) : null;
          var tmp_1;
          if (isPolymorphicSerializer) {
            var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (value == null) {
                var message = 'Value for serializer ' + toString_0(serializer.get_descriptor_wjt6a0_k$()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString_0(message));
              } else {
                break $l$block_0;
              }
            }
            var actual = findPolymorphicSerializer(casted, this, value);
            tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
          } else {
            tmp_1 = serializer;
          }
          var actualSerializer = tmp_1;
          if (!(baseClassDiscriminator == null)) {
            access$checkEncodingConflicts$tPolymorphicKt(this.get_json_woos35_k$(), serializer, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$());
            var serialName = actualSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
            this.polymorphicDiscriminator_1 = baseClassDiscriminator;
            this.polymorphicSerialName_1 = serialName;
          }
          actualSerializer.serialize_5ase3y_k$(this, value);
        }
      }
      beginStructure_yljocp_k$(descriptor) {
        var newMode = switchMode(this.json_1, descriptor);
        if (!(newMode.begin_1 === _Char___init__impl__6a9atx(0))) {
          this.composer_1.print_49c4ow_k$(newMode.begin_1);
          this.composer_1.indent_cuntic_k$();
        }
        var discriminator = this.polymorphicDiscriminator_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.polymorphicSerialName_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.get_serialName_u2rqhk_k$() : tmp0_elvis_lhs);
          this.polymorphicDiscriminator_1 = null;
          this.polymorphicSerialName_1 = null;
        }
        if (this.mode_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.modeReuseCache_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.ordinal_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().new_kotlinx_serialization_json_internal_StreamingJsonEncoder_dldtnx_k$(this.composer_1, this.json_1, newMode, this.modeReuseCache_1) : tmp2_elvis_lhs;
      }
      endStructure_1xqz0n_k$(descriptor) {
        if (!(this.mode_1.end_1 === _Char___init__impl__6a9atx(0))) {
          this.composer_1.unIndent_45q4lx_k$();
          this.composer_1.nextItemIfNotFirst_9wb040_k$();
          this.composer_1.print_49c4ow_k$(this.mode_1.end_1);
        }
      }
      encodeElement_5v7eyb_k$(descriptor, index) {
        switch (this.mode_1.ordinal_1) {
          case 1:
            if (!this.composer_1.writingFirst_1) {
              this.composer_1.print_49c4ow_k$(_Char___init__impl__6a9atx(44));
            }

            this.composer_1.nextItem_40n9p2_k$();
            break;
          case 2:
            if (!this.composer_1.writingFirst_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.composer_1.print_49c4ow_k$(_Char___init__impl__6a9atx(44));
                this.composer_1.nextItem_40n9p2_k$();
                tmp_0 = true;
              } else {
                this.composer_1.print_49c4ow_k$(_Char___init__impl__6a9atx(58));
                this.composer_1.space_po67ue_k$();
                tmp_0 = false;
              }
              tmp.forceQuoting_1 = tmp_0;
            } else {
              this.forceQuoting_1 = true;
              this.composer_1.nextItem_40n9p2_k$();
            }

            break;
          case 3:
            if (index === 0)
              this.forceQuoting_1 = true;
            if (index === 1) {
              this.composer_1.print_49c4ow_k$(_Char___init__impl__6a9atx(44));
              this.composer_1.space_po67ue_k$();
              this.forceQuoting_1 = false;
            }

            break;
          default:
            if (!this.composer_1.writingFirst_1) {
              this.composer_1.print_49c4ow_k$(_Char___init__impl__6a9atx(44));
            }

            this.composer_1.nextItem_40n9p2_k$();
            this.encodeString_424b5v_k$(getJsonElementName(descriptor, this.json_1, index));
            this.composer_1.print_49c4ow_k$(_Char___init__impl__6a9atx(58));
            this.composer_1.space_po67ue_k$();
            break;
        }
        return true;
      }
      encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value) {
        if (!(value == null) || this.configuration_1.explicitNulls_1) {
          super.encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value);
        }
      }
      encodeInline_wxp5pu_k$(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.composer_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.composer_1;
          } else {
            var tmp0 = this.composer_1.writer_1;
            var p1 = this.forceQuoting_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$0 = tmp_0;
          tmp = StreamingJsonEncoder().new_kotlinx_serialization_json_internal_StreamingJsonEncoder_dldtnx_k$(tmp$ret$0, this.json_1, this.mode_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.composer_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.composer_1;
          } else {
            var tmp0_0 = this.composer_1.writer_1;
            var p1_0 = this.forceQuoting_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$2 = tmp_2;
          tmp = StreamingJsonEncoder().new_kotlinx_serialization_json_internal_StreamingJsonEncoder_dldtnx_k$(tmp$ret$2, this.json_1, this.mode_1, null);
        } else if (!(this.polymorphicDiscriminator_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.polymorphicSerialName_1 = descriptor.get_serialName_u2rqhk_k$();
          tmp = this;
        } else {
          tmp = super.encodeInline_wxp5pu_k$(descriptor);
        }
        return tmp;
      }
      encodeNull_ejiosz_k$() {
        this.composer_1.print_wtfns3_k$('null');
      }
      encodeBoolean_tu2e59_k$(value) {
        if (this.forceQuoting_1) {
          this.encodeString_424b5v_k$(value.toString());
        } else {
          this.composer_1.print_u0bpvs_k$(value);
        }
      }
      encodeByte_6txfee_k$(value) {
        if (this.forceQuoting_1) {
          this.encodeString_424b5v_k$(value.toString());
        } else {
          this.composer_1.print_p65m4b_k$(value);
        }
      }
      encodeShort_gza6si_k$(value) {
        if (this.forceQuoting_1) {
          this.encodeString_424b5v_k$(value.toString());
        } else {
          this.composer_1.print_l5t6fv_k$(value);
        }
      }
      encodeInt_y5zi3z_k$(value) {
        if (this.forceQuoting_1) {
          this.encodeString_424b5v_k$(value.toString());
        } else {
          this.composer_1.print_ay1yo5_k$(value);
        }
      }
      encodeLong_vlw3uq_k$(value) {
        if (this.forceQuoting_1) {
          this.encodeString_424b5v_k$(value.toString());
        } else {
          this.composer_1.print_u23kfb_k$(value);
        }
      }
      encodeFloat_b8b85a_k$(value) {
        if (this.forceQuoting_1) {
          this.encodeString_424b5v_k$(value.toString());
        } else {
          this.composer_1.print_81xt5n_k$(value);
        }
        if (!this.configuration_1.allowSpecialFloatingPointValues_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      encodeDouble_n270q9_k$(value) {
        if (this.forceQuoting_1) {
          this.encodeString_424b5v_k$(value.toString());
        } else {
          this.composer_1.print_3xddxz_k$(value);
        }
        if (!this.configuration_1.allowSpecialFloatingPointValues_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      encodeChar_id8ngf_k$(value) {
        this.encodeString_424b5v_k$(toString(value));
      }
      encodeString_424b5v_k$(value) {
        return this.composer_1.printQuoted_gtxn2t_k$(value);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        this.encodeString_424b5v_k$(enumDescriptor.getElementName_u4sqmf_k$(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.get_isInline_usk17w_k$() && get_unsignedNumberDescriptors().contains_aljjnj_k$(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.get_isInline_usk17w_k$() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).get_descriptor_wjt6a0_k$(), serializer_0(Companion_getInstance_0()).get_descriptor_wjt6a0_k$(), serializer_1(Companion_getInstance_1()).get_descriptor_wjt6a0_k$(), serializer_2(Companion_getInstance_2()).get_descriptor_wjt6a0_k$()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnquotedLiteral as get_isUnquotedLiteral1m5ywe5x8bka4,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
